// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KTs5","right":"styles_right__1hg0S"};